import Service from "./Service";
import { PageList } from "@/model/system";
import { DriverLocation } from "@/model/Traffic";
class trafficPolicyService extends Service {
  getAddress(data: any) {
    return this.post<PageList<any>>(`/product/QueryAddress`, data);
  }
  getProductList(data: any) {
    return this.post<PageList<any>>(`/product/list`, data);
  }
  queryDriver(id: string, index: number) {
    return this.post<DriverLocation[]>(`Product/queryDriver?id=${id}&index=${index}`, {});
  }

  routePlan(origin: string, destination: string) {
    return this.get<any>(`Product/driving?origin=${origin}&destination=${destination}`);
  }
}
export default new trafficPolicyService("trafficPolicy");
